export const TRANSACTION_HISTORY_MANAGEMENT_CONSTANTS = {
    DEFAULT_TRANSACTIONS_PER_PAGE: 10,
    CONTAINER_HEIGHT: '95vh',
    SNACKBAR_DURATION: 6000,
    
    // Tab labels
    TABS: {
      TRANSACTIONS: 'Transactions',
      REPORT: 'Report'
    }
  } as const;